import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  subcategories: [],
  subcategory: {},
  totalSubcategories: 0
};

const getters = {};

const actions = {
  LOAD_SUBCATEGORY: function({ commit, rootState }, payload) {
    return Vue.prototype.$axios
      .get("product_subcategories/" + payload.productSubcategoryId)
      .then(
        response => {
          commit("SET_SUBCATEGORY", response.data.productSubcategory);
        },
        err => {
          throw new Error(err);
        }
      );
  },
  LOAD_SUBCATEGORIES: async function({ commit, rootState }, payload) {
    let nameQuery =
      payload.name && payload.name !== " " ? "&name=" + payload.name : "";
    let productCategoryQuery = payload.productCategoryId
      ? "&productCategoryId=" + payload.productCategoryId
      : "";
    let productSubcategoryTypeQuery = payload.productSubcategoryTypeId
      ? "&productSubcategoryTypeId=" + payload.productSubcategoryTypeId
      : "";
    return await Vue.prototype.$axios
      .get(
        "/product_subcategories?from=" +
          payload.from +
          "&limit=" +
          payload.to +
          nameQuery +
          productCategoryQuery +
          productSubcategoryTypeQuery
      )
      .then(
        response => {
          commit("SET_SUBCATEGORIES", response.data.productSubcategories);
          commit("SET_TOTAL_SUBCATEGORIES", response.data.meta.total);
          return response;
        },
        err => {
          throw new Error(err);
        }
      );
  },
  UPDATE_SUBCATEGORY_APPROVED_STATUS: function(
    { commit, rootState, dispatch },
    payload
  ) {
    return Vue.prototype.$axios
      .patch(
        "/prooducts/" + payload.subcategoryId,
        {
          approved: payload.approved
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(
        response => {},
        err => {
          throw new Error(err.response.data.meta.message);
        }
      );
  },
  CREATE_SUBCATEGORY: function({ commit, dispatch }, payload) {
    return Vue.prototype.$axios.post("/product_subcategories", payload).then(
      response => {},
      err => {
        throw new Error(err.response.data.meta.message);
      }
    );
  },
  UPDATE_SUBCATEGORY: async function({ commit }, payload) {
    return Vue.prototype.$axios
      .post("/product_subcategories/" + payload.id, payload)
      .then(
        response => {},
        err => {
          throw new Error(err.response.data.meta.message);
        }
      );
  },
  DESTROY_SUBCATEGORY: async function({ commit }, payload) {
    return Vue.prototype.$axios
      .delete("/product_subcategories/" + payload)
      .then(
        response => {},
        err => {
          throw new Error(err.response.data.meta.message);
        }
      );
  }
};

const mutations = {
  SET_SUBCATEGORIES: (state, subcategories) => {
    state.subcategories = subcategories;
  },
  SET_TOTAL_SUBCATEGORIES: (state, totalSubcategories) => {
    state.totalSubcategories = totalSubcategories;
  },
  SET_SUBCATEGORY: (state, subcategory) => {
    state.subcategory = subcategory;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
